<template>
  <div class="detail">
    <TabBar_m />
    <loading v-if="isLoading" />
    <div class="cases_box" v-else>
      <div class="banner" :style="{'backgroundImage': 'url(' + casesItem.backgroundurl + ')'}">
        <div class="title">
          <h3>{{casesItem.h4}}</h3>
          <i></i>
          <h6>{{casesItem.titleH6}}</h6>
        </div>
        <div class="cases_brief">
          <h3>项目简介</h3>
          <h5>{{casesItem.txtH5}}</h5>
          <p>{{casesItem.p1}}</p>
          <p>{{casesItem.p2}}</p>
          <p>{{casesItem.p3}}</p>
          <p>{{casesItem.p4}}</p>
        </div>
      </div>
      <div class="cases_img">
        <img :src="casesItem.bigbackgroundurl" alt />
      </div>
    </div>
    <Footer_m />
  </div>
</template> 

<script>
import Bus from "../Bus";
import loading from "../components/Loading";
export default {
  components: {
    loading,
  },
  props: {},
  data() {
    return {
      casesItem: "",
      isLoading: true,
    };
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {
    Bus.$on("listenToA", (val) => {
      this.casesItem = val;
      this.isLoading = false;
    });
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  height: 2000px;
}
.cases_box {
  .banner {
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: top;
    margin-top: 50px;
    padding: 0 16px;
    overflow: hidden;

    .title {
      color: #fff;
      margin: 65px 0 44px;
      h6 {
        line-height: 10px;
        font-size: 8px;
        text-transform: uppercase;
        font-weight: bold;
        -webkit-transform-origin-x: 0; /*缩小后文字居左*/
        -webkit-transform: scale(0.7); /*缩小90%*/
      }
      i {
        display: block;
        width: 30px;
        height: 2px;
        background: #fff;
        margin: 4px 0;
      }
      h3 {
        line-height: 25px;
        font-size: 18px;
        margin-bottom: 4px;
      }
    }
    .cases_brief {
      padding: 16px;
      background: #ffffff;

      box-shadow: 0px 5px 10px rgba(0, 9, 94, 0.11);

      top: 0;
      h3 {
        font-size: 18px;
        line-height: 25px;
        color: #26acff;
      }
      h5 {
        font-size: 15px;
        line-height: 20px;
        margin: 8px 0;
      }
      p {
        text-indent: 2em;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
.cases_img {
  margin-top: 24px;
  img {
    width: 100%;
  }
}
</style>